"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledAspectRatioObject = exports.StyledAspectRatioContainer = void 0;

var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _ty = _interopRequireDefault(require("../../framework/ty"));

var _templateObject;

var StyledAspectRatioContainer = _styledComponents["default"].div.withConfig({
  displayName: "RatioBoxstyles__StyledAspectRatioContainer",
  componentId: "sc-191zb2z-0"
})(["height:0;position:relative;", " ", ""], function (_ref) {
  var image = _ref.image;
  return image && (0, _ty["default"])(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["bg-mid-gray"])));
}, function (_ref2) {
  var h = _ref2.h,
      w = _ref2.w;
  var paddingBottom = h / w * 100;
  return "\n      padding-bottom: ".concat(paddingBottom, "%;\n    ");
});

exports.StyledAspectRatioContainer = StyledAspectRatioContainer;

var StyledAspectRatioObject = _styledComponents["default"].div.withConfig({
  displayName: "RatioBoxstyles__StyledAspectRatioObject",
  componentId: "sc-191zb2z-1"
})(["position:absolute;top:0;right:0;bottom:0;left:0;width:100%;height:100%;background-size:cover;background-position:center;"]);

exports.StyledAspectRatioObject = StyledAspectRatioObject;